import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Avatar from 'src/components/avatar';
import { showSignupModal } from 'src/modules/shared/modal/actions';
import signupContext from 'src/constants/signupContext';
import { trackFootfallEvent } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import i18n from 'i18next';

export class UserLink extends React.Component {
  static propTypes = {
    avatar: PropTypes.bool,
    avatarSize: PropTypes.string,
    className: PropTypes.string,
    isTargetBlank: PropTypes.bool,
    itemProp: PropTypes.string,
    signupContext: PropTypes.object,
    user: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    avatar: false,
    isTargetBlank: false,
    signupContext: {
      section: signupContext.section.UNTRACKED,
      element: signupContext.element.USER_LINK,
    },
    isLoggedIn: true,
    onClick: () => {},
  };

  onClick = event => {
    this.props.onClick();
    if (!this.props.isLoggedIn) {
      event.preventDefault();
      trackFootfallEvent(footfallEventTypes.CLICKED, {
        clickType: 'sign-up',
        clickMetadata: this.props.signupContext,
      });
      this.props.showSignupModal(this.props.signupContext);
      return;
    }
  };

  render() {
    const { avatar, avatarSize, className, isTargetBlank, itemProp, user } = this.props,
      username = user.username || '',
      url = `${isTargetBlank ? `${window.location.protocol}//${window.location.host}` : ''}/user/${username}`,
      isLoading = !username, // is this good enough? if there is no username, it's definitely not loaded, right?
      isHiddenOrDeleted = !user || (Object.keys(user).length > 0 && user.isHidden) || username === 'Hidden',
      contentText = isHiddenOrDeleted ? i18n.t('Hidden') : isLoading ? i18n.t('Loading...') : username,
      content = avatar ? <Avatar name={username} size={avatarSize}
        src={user.avatar} /> : contentText,
      meta = <meta content={contentText} itemProp="name" />;

    // Show loading user as loading
    if (isLoading) {
      return (
        <span className={className}>
          {avatar ? avatar : contentText}
          {meta}
        </span>
      );
    }

    // No link for hidden/deleted users
    if (isHiddenOrDeleted) {
      return (
        <span className={className} itemProp={itemProp}>
          {content}
          {meta}
        </span>
      );
    }

    return (
      <a
        className={className}
        href={url}
        itemProp="url"
        rel="nofollow"
        target={isTargetBlank ? '_blank' : null}
        onClick={this.onClick}
      >
        {content}
        {meta}
      </a>
    );
  }
}

export default connect(
  null,
  { showSignupModal },
)(UserLink);



// WEBPACK FOOTER //
// ./src/modules/shared/links/userLink.js